/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import CustomizedSteppers from 'src/components/Modules/Farmer/Pages/CompletionBar';

var screenCode = "FARMER"

export default function FarmerAddEdit(props) {

  const navigate = useNavigate();
  const [groupFactory, setGroupFactory] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    nicEdit: true,
    isEditType: 1,
    submitButtonName: "Save",
    pageheadername: "Supplier Registration"
  });

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setGroupFactory({
      ...groupFactory,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
  }

  return (

    <Page title="Add Farmer  |  FAPS">
      <Container>
        <CommonPageHeader
          path="/dashboard/farmer/"
          btname="Back"
          pageName={pageProps.pageheadername}
        />
        <CustomizedSteppers />
      </Container>
    </Page >
  )
}